export enum EditChecklistType {
    LABEL = 'label',
    TYPE = 'type',
}